export const TYPE_LIST_RATE_METHOD: string[] = [
    "Cubic Feet",
    "Weight",
    "Linear Feet"
];

export const TYPE_LIST_SERVICE: string[] = [
    "Accessorial Service",
    "Surcharge Service",
    "Tradeshow Service",
    "Trailer Build Service",
    "Customs Service",
    "Delivery Service",
    "Pickup Service",
    "Labourer Service"
];

export const TYPE_LIST_ORDER_SCOPE: string[] = [
    "Tradeshow",
    "Storage",
    "Trailer Build",
    "Warehouse",
    "Household",
    "Plug Play",
    "Blanketed",
    "Dock to Dock",
    "White Glove",
    "Military Site",
    "Extraction",
    "Disposal",
    "Job Site"
];

export const TYPE_LIST_EQUIPMENT_TYPE: string[] = [
    "V - Van",
    "R - Refrigerated Carrier (Reefer)",
    "F - Flatbed",
    "TWOF - Two 24 or 28 foot Flats",
    "ANIM - Animal Carrier",
    "ANYE - Any Equipment",
    "AUTO - Auto carrier",
    "B_TR - B-Train/Supertrain",
    "BDMP - Belly Dump",
    "BEAM - Beam",
    "BELT - Conveyor Belt",
    "BOAT - Boat Hauling Trailer",
    "CH - Convertible Hopper",
    "CONG - Conestoga",
    "CONT - Container Trailer",
    "CV - Curtain Van",
    "DA - Drive Away",
    "DD - Double Drop",
    "DDE - Double Drop Extendable",
    "DUMPT - Dump Trucks",
    "ENDP - End Dump",
    "FA - FlatBed - Air-Ride",
    "FEXT - Stretch Trailers or Extendable",
    "FINT - Flatbed Intermodal",
    "FO - Flatbed Over-Dimension Loads",
    "FSD - Flat or Step Deck",
    "FSDV - Flatbed, Step Deck, or Van",
    "FV - Van or Flatbed",
    "FVR - Flatbed, Van, or Reefer",
    "FVV - Flatbed or Vented Van",
    "FVVR - Flatbed, Vented Van, or Reefer",
    "FWS - Flatbed With Sides",
    "HOPP - Hopper Bottom",
    "HS - Hot Shot",
    "HTOW - Haul and Tow Unit",
    "LAF - Landoll Flatbed",
    "LB - Lowboy",
    "LBO - Lowboy over-dimension load",
    "LDOT - Load-Out are empty trailers you load and haul",
    "LIVE - Live Bottom Trailer",
    "MAXI - Maxi or Double Flat Traillers",
    "MBHM - Mobile Home",
    "PNEU - Pneumatic",
    "PO - Power Only (tow-away)",
    "RFV - Flatbed, Van, or Reefer",
    "RGN - Removable Goose Neck & Multi-Axle Heavy Haulers",
    "RGNE - RGN Extendable",
    "RINT - Refrigerated Intermodal",
    "ROLL - ROLL Top Conestoga",
    "RPD - Refrigerated Carrier W/Plant Decking",
    "RV - Van or Reefer",
    "RVF - Flatbed, Van, or Reefer",
    "SD - Step Deck",
    "SDE - Step Deck Extendable",
    "SDL - Step Deck w/Loading Ramps",
    "SDO - Step Deck over-dimension load",
    "SDRG - Step Deck or RemovableGooseneck",
    "SPEC - Unspecified Specialized",
    "HCV - High Cube Van",
    "ST - Straight Truck",
    "TANK - Tanker",
    "V_OT - Open Top Van",
    "VA - Van - Air-Ride",
    "VB - Blanket Wrap Van",
    "VCAR - Cargo Vans (1 Ton capacity)",
    "VF - Flatbed or Van",
    "VFR - Flatbed, Van, or Reefer",
    "VINT - Van Intermodal",
    "VIV - Vented Insulated Van",
    "VIVR - Vented Insulated Van or Refrigerated",
    "VLG - Van w/Liftgate",
    "VM - Moving Van",
    "VR - Van or Reefer",
    "VRDD - Van, Reefer Double Drop",
    "VRF - Flatbed, Van, or Reefer",
    "VV - Vented Van",
    "VVR - Vented Van or Refrigerated",
    "WALK - Walking Floor Odometer"
];

export const TYPE_LIST_EQUIPMENT_OPTIONS: string[] = [
    "Tarps",
    "Hazardous",
    "PalletExchange",
    "Team",
    "Tilt Load Lift Equipment",
    "Expedited",
    "Bonded",
    "Power Tailgate",
    "Spot/Drop Trailer",
    "Mult-Stop",
    "Blanket Wrap",
    "Temperature Control",
    "Air Ride",
    "Satellite Tracking",
    "Heated",
    "Lumper/Swamper",
    "Tradeshow"
];

export const TYPE_LIST_PARTIAL_FULL: string[] = [
    "Partial",
    "Full"
];

export const TYPE_LIST_ACCESSORIAL: string[] = [
    "Barge Service",
    "Beyond Charge",
    "Bulky Article",
    "Cartage",
    "Change In terms of Pay",
    "Container Lift Crane",
    "Correct BOL Charge",
    "Courier",
    "Crossdock",
    "DDP Charges",
    "Dangerous Goods",
    "Detention",
    "Disposal Fee",
    "Drayage",
    "Exclusive Use",
    "Expedite",
    "Export Shipping Charge",
    "Extraction",
    "Facility Fee",
    "Forklift",
    "Haz Mat",
    "Heated Service",
    "Inspection Fee",
    "Inward Charge",
    "Layover",
    "Linehaul Inbound",
    "Linehaul Outbound",
    "Linehaul",
    "Linked Expense",
    "Loading",
    "Maintenance",
    "Marking Tagging",
    "Materials",
    "Minimum Charge",
    "Off Line Miles",
    "Over The Road",
    "Pallet Allowance",
    "Redirect",
    "Refused",
    "Return To Shipper",
    "Reworking Freight",
    "Scale Ticket",
    "Scrap Yard Fees",
    "Segregation Charge",
    "Service Charge",
    "Single Shipment",
    "Site Inspection",
    "Skid Fee",
    "Skid Wrapping",
    "Sortation Charge",
    "Stair Crawler",
    "Stop Off",
    "Storage In Transit",
    "Supplies",
    "Tarping",
    "Team Service",
    "Tilt Load Lift Equipment",
    "Tolls",
    "Trailer Drop",
    "Trailer Repair",
    "Trailer Shunt",
    "Trailer Storage",
    "Truck Furnished Not Used",
    "Truck Overflow",
    "Unloading",
    "Waiting Overtime",
    "Waiting Time",
    "Weight Inspection Fee",
    "White Glove Service"
];

export const TYPE_LIST_SURCHARGE: string[] = [
    "Delivery Surcharge",
    "Carbon Surcharge",
    "Haz Mat Surcharge",
    "Fuel Surcharge LTL",
    "Fuel Surcharge TL",
    "Fuel Surcharge Flat",
    "Non Conveyable Surcharge",
    "Fuel Surcharge",
    "Pan Am Games",
    "Service Surcharge"
];

export const TYPE_LIST_TRADESHOW: string[] = [
    "Tradeshow Adminstration",
    "Tradeshow Delivery",
    "Tradeshow Pickup"
];

export const TYPE_LIST_TRAILER_BUILD: string[] = [
    "Build Cleaning",
    "Build Consulting",
    "Build Contruction",
    "Build Cover Storage",
    "Build Delivery",
    "Build Detention",
    "Build GPS",
    "Build License Plates",
    "Build Maintenance",
    "Build Material",
    "Build Missed Pickup",
    "Build Nets",
    "Build Permit",
    "Build Purchase",
    "Build Repair",
    "Build Shelf Covers",
    "Build Shunt",
    "Build Storage",
    "Build Truck Wash",
    "Build Waiting Time",
    "Build Wrap"
];

export const TYPE_LIST_CUSTOMS: string[] = [
    "Border Delay",
    "Border Security",
    "Border Crossing",
    "Bond Charge",
    "Bond with Re-Delivery",
    "Customs Detention",
    "Customs Devanning",
    "Customs Brokerage",
    "Customs Exam",
    "Duty"
];

export const TYPE_LIST_DELIVERY: string[] = [
    "Delivery After Hours",
    "Delivery Appointment",
    "Delivery Detention",
    "Delivery Rate",
    "Delivery Extra",
    "Delivery Inside",
    "Re-Delivery",
    "Delivery Residential",
    "Delivery Tailgate",
    "Delivery Weekend",
    "Delivery Notification",
    "Delivery Straight Truck",
    "Delivery Time Specific",
    "Delivery Date Time Specific",
    "Split Delivery",
    "Delivery Downtown",
    "Delivery Highcost Area",
    "Delivery Limited Access",
    "Delivery Attempted",
    "Delivery Advance Hours",
    "Delivery Certified",
    "Delivery Back Door"
];

export const TYPE_LIST_PICKUP: string[] = [
    "Pickup After Hours",
    "Pickup Extra",
    "Pickup Missed",
    "Pickup Tailgate",
    "Pickup Weekend",
    "Pickup Straight Truck",
    "Pickup Detention",
    "Pickup Origin",
    "Pickup Residential",
    "Pickup Single Shipment",
    "Pickup Rate",
    "Pickup Extra",
    "Pickup Inside",
    "Pickup Certified",
    "Pickup Time Specific",
    "Pickup Date Time Specific"
];

export const TYPE_LIST_LABOURER: string[] = [
    "Helper",
    "Helper Overtime",
    "Crew Leader",
    "Labour",
    "Warehouse Labour",
    "Lumper Handling",
    "Labour Mileage",
    "Driver Assist",
    "Technogym Handling & Installation"
];
